import { LatLngExpression } from 'leaflet';

/**
 * Format nationaal georegister POINT(lng, lat) to [lat, lng]
 *
 * @param {string} centroide_ll - Centroide (POINT) from nationaal georegister.
 *
 * @returns {LatLngExpression} The formatted [lat, lng] array.
 */
export default (centroide_ll: string): LatLngExpression | null => {
  if (!centroide_ll) return null;

  const [lng, lat] = centroide_ll
    .split('(')[1]
    .split(')')[0]
    .split(' ');

  return [Number(lat), Number(lng)];
};
